import { useMyEvents } from 'clients/internal/homeService';

const useUserRoles = () => {
  // fetch all the user's events
  const { data, isLoading } = useMyEvents();

  const hostingEvents = data?.hostingEvents || [];
  const attendingEvents = data?.attendingEvents || [];
  const reviewingEvents = data?.reviewingEvents || [];
  const allUserEvents = [
    ...hostingEvents,
    ...reviewingEvents,
    ...attendingEvents
  ];

  // based on events, determine user roles
  const foundRoles = new Set(allUserEvents.map(e => e.roles).flat());

  const isReviewer = foundRoles.has('reviewer');
  const isOrganizer = foundRoles.has('organizer');
  const isAuthor = foundRoles.has('author');
  const isSectionEditor = foundRoles.has('section_editor');
  const isPaperReviewer = foundRoles.has('paper-reviewer');
  const isPublisherRepresentative = foundRoles.has('publisher_representative');

  return {
    isReviewer,
    isOrganizer,
    isAuthor,
    isSectionEditor,
    isPaperReviewer,
    isPublisherRepresentative,
    isLoading,
    hostingEvents,
    reviewingEvents,
    attendingEvents
  };
};

export default useUserRoles;
